/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/control-has-associated-label */

import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const PopUpWrapper = styled.div`
    height: 100%;
    width: 31%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
`;

const PopUpContainer = styled.div`
    position: absolute;
    width: 520px;
    height: 280px;
    background: #ffffff;
    box-shadow: 0px 0px 24px rgb(0 0 0 / 18%);
    border-radius: 8px;
    text-align: center;
    position: absolute;
    font-family: 'Roboto', sans-serif;
    z-index: 1000;
`;

const HeaderText = styled.div`
    font-weight: bold;
    font-size: 24px;
    padding: 20px;
`;

const ParagraphText = styled.div`
    font-weight: 500;
    font-size: 16px;
    padding: 0px 20px 0px;
`;

const ButtonsContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
`;

const DropDownContainer = styled.div`
    height: fit-content;
    display: inline-grid;
    align-items: center;
`;

const ButtonSend = styled.div`
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    color: ${props => props.theme.colors.white};
    background: ${props => props.theme.colors.darkGreen};
    border-radius: 4px;
    height: 50px;
    width: 216px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    :active {
        background: ${props => props.theme.colors.lightGray};
    }
`;

const SelectInput = styled.select`
    width: 18.75rem;
    height: 3.125rem;
    border: 1px solid ${props => props.theme.colors.gray};
    border-radius: 4px;
    font-size: 16px;
    padding-left: 19px;
    ::-ms-reveal {
        display: none;
    }
    background: white;
`;

const IntervalDiv = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    zIndex: 999;
    background: #2B2B32;
    opacity: 0.8;
`;

export function LoginDropdown({
    options,
    onChange,
    accessIndex,
    containerRef,
    placeholder = ""
}) {
    const { t } = useTranslation();
    console.log(options);
    return (
        <DropDownContainer>
            <SelectInput defaultValue="" ref={containerRef} onChange={(event) => {
                containerRef.current.style.borderColor = "black";
                containerRef.current.style.outline = "black";
                containerRef.current.style.color = "black";
                onChange(event.target.value);
            }}>
                <option value="" disabled hidden >
                    &nbsp;
                </option>
                {options?.map((account, index) => (
                    <option
                        key={index}
                        value={index}
                        style={{ color: "black" }}
                    >
                        {account[accessIndex]}
                    </option>
                ))}
            </SelectInput>
        </DropDownContainer>
    )
}
